import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  container: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    height: "100%",
    bgcolor: "background.paper",
    boxShadow: "24px",
    p: 4,
    backgroundColor: "white",
    padding: "20px 20px",
  },
  titleSection: {
    fontSize: "30px",
    fontWeight: 600,
    fontFamily: "Inter",
  },
  filtersForm: {
    marginTop: "20px",
  },
  filterLabel: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "22px",
    margin: "10px 0",
  },
  filtersItems: {
    fontWeight: 400,
    fontFamily: "Inter",
    fontSize: "16px",
  },
  buttonsContainer: {
    marginTop: "20px",
  },
});
